import { CheckCircle, Shield, } from 'lucide-react';
import Tick from '../assets/image/greentick.png'
import Lock from '../assets/image/lock.png'
import Rect from '../assets/image/Rectangle.png'
import RBI from '../assets/image/rbi.png'
import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef } from "react";


export default function Security() {
   const navigate = useNavigate()
   const cardRefs = useRef([]);
       const headlineRef = useRef(null);
       const descriptionRef = useRef(null);
     
       
       useEffect(() => {
       const observer = new IntersectionObserver(
         (entries) => {
           entries.forEach((entry) => {
             if (entry.isIntersecting) {
               entry.target.classList.add("animate-show");
             }
           });
         },
         { threshold: 0.3 }
       );
     
       // Observe loan cards
       cardRefs.current.forEach((el) => {
         if (el) observer.observe(el);
       });
     
       // Observe headline
       if (headlineRef.current) observer.observe(headlineRef.current);
        if (descriptionRef.current) observer.observe(descriptionRef.current);
     
       return () => observer.disconnect();
     }, []);
  
  return (
    <> 
     <style>{`.card-base {
          transition: opacity 0.3s ease-out;
        }

        .animate-show {
          animation: floatIn 1s ease-out both;
          opacity: 1;
        }

        @keyframes floatIn {
          0% {
            opacity: 0;
            transform: translateY(30px) scale(0.95);
          }
          100% {
            opacity: 1;
            transform: translateY(0px) scale(1);
          }
        }

        .word-animate {
          display: inline-block;
          opacity: 0;
          transform: translateY(20px);
        }

        .animate-show .word-animate {
          animation: wordReveal 0.4s ease-out forwards;
        }
       

        @keyframes wordReveal {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
   
           <section id='security' className="pt-[60px] md:pt-[60px] lg:pt-[72px] pb-[20px] md:pb-[40px] lg:pb-[66px]  justify-center ">
      <div className='max-w-[1280px] mx-auto px-4  sm:px-6 md:px-10 lg:px-12 '>

          <div className='  flex flex-col gap-[24px]  mx-auto -mb-2 sm:-mb-4 lg:-mb-4 max-w-[322px] sm:max-w-[402px] md:max-w-[460px] lg:max-w-[582px]'>

              <div className="flex justify-center  items-center  mb-6">
              <div ref={descriptionRef}
                    className=" headline-animate w-fit h-fit  border-[#0BA36C] border-[1.5px] rounded-tl-[21px] rounded-tr-[6px] rounded-bl-[5px] rounded-br-[6px] pt-[4px] pr-[16px] pl-[16px] pb-[5px] ">
                <span className=" text-[#0BA36C] text-[16px] font-inter font-semibold">Security</span>
              </div>
            </div>
            <h2
  ref={headlineRef}
 className="  text-[28px] leading-[36px]  font-poppins  sm:text-[30px]  md:text-[48px] lg:text-[48px] sm:leading-[36px] md:leading-[50px] lg:leading-[62px] font-medium  -tracking-[4%] text-gray-900 text-center">
  {["Security", "&", "Support"].map((word, i) => (
    <span
      key={i}
      className="word-animate"
      style={{ animationDelay: `${i * 0.08}s` }}
    >
      {word}&nbsp;
    </span>
  ))}

  <br/>

  {["You", "Can", "Trust"].map((word, i) => (
    <span
      key={i + 4}
      className="word-animate text-[#0BA36C]"
      style={{ animationDelay: `${(i + 4) * 0.08}s` }}
    >
      {word}&nbsp;
    </span>
  ))}

 
</h2>
            
                 
                  <div className="flex mx-auto items-center text-center justify-center gap-3 h-fit">
                    <img
                      src={Tick}
                      className="rounded-full h-[29px] w-[29px] object-contain"
                    />

                    <h1 className="text-[#0BA36C] text-[22px] sm:text-[22px] md:text-[22px] lg:text-[22px]
                                  font-poppins font-medium -tracking-[4%] leading-none">
                      No Unofficial Charges
                    </h1>
                  </div>

                  <p className="text-center text-[#404040] text-[17px]  mb-12 max-w-[460px] mx-auto sm:text-[17px] md:text-[17px] lg:text-[18px] ">
We never ask for additional fees to speed up processing or reduce interest rates. What you see is what you get.</p>          
          
          </div >
          
          {/* No Unofficial Charges - Full Width */}
          

          {/* Two Column Cards */}
          <div className="grid md:grid lg:grid-cols-2 gap-[52px]  mx-auto mb-8">

            <div className="  bg-cover bg-center rounded-tl-[60px] w-full h-fit rounded-tr-[20px] rounded-bl-[20px] rounded-br-[20px] rounded-bl-[20px] border-[0.5px] border-[#00000033] "
            style={{ backgroundImage: `url(${Rect})` }} >
              <div className=" flex flex-col sm:flex-col   md:flex-row  items-start sm:items-start md:items-stretch gap-[32px] py-[17px] px-[18px] md:py-[18px] md:px-[18px] lg:py-[26px] lg:px-[24px] rounded-tl-[60px] rounded-tr-[20px] rounded-bl-[20px] rounded-br-[20px] rounded-bl-[20px] border-[6px] border-[#0000000D]  shadow-xl ">
                <div className="w-fit h-fit rounded-2xl flex items-center justify-center flex-shrink-0">
                  <img src={Lock} className=" w-[154.19000244140625px] h-[154.19000244140625px] md:w-[164.19000244140625px] md:h-[164.19000244140625px] lg:w-[105.19000244140625px] lg:h-[105.19000244140625px] rounded-2xl flex items-center justify-center flex-shrink-0" />
                </div>
                <div className=' flex flex-col '>
                  <h3 className="text-[23.31px] md:text-[23.31px] lg:text-[22.31px] font-inter font-semibold text-black mb-3">
                    Your Data Stays Private
                  </h3>
                  <p className="text-[#3F3F3F]  text-[17px] md:text-[16px] leading-relaxed">
                    We do not share or sell your information to third-party marketers or external agencies.
                  </p>
                </div>
              </div>
            </div>

            <div className="  bg-cover bg-center rounded-tl-[60px] w-full h-fit rounded-tr-[20px] rounded-bl-[20px] rounded-br-[20px] rounded-bl-[20px] border-[0.5px] border-[#00000033] "
            style={{ backgroundImage: `url(${Rect})` }} >
              <div className=" flex flex-col sm:flex-col   md:flex-row  items-start sm:items-start md:items-stretch gap-[32px] py-[17px] px-[18px] md:py-[18px] md:px-[18px] lg:py-[26px] lg:px-[24px] rounded-tl-[60px] rounded-tr-[20px] rounded-bl-[20px] rounded-br-[20px] rounded-bl-[20px] border-[6px] border-[#0000000D]  shadow-xl ">
                <div className="w-fit h-fit rounded-2xl flex items-center justify-center flex-shrink-0">
                  <img src={RBI} className=" w-[154.19000244140625px] h-[154.19000244140625px] md:w-[164.19000244140625px] md:h-[164.19000244140625px] lg:w-[105.19000244140625px] lg:h-[105.19000244140625px] rounded-2xl flex items-center justify-center flex-shrink-0" />
                </div>
                <div className=' flex flex-col '>
                  <h3 className="text-[23.31px] md:text-[23.31px] lg:text-[22.31px] font-inter font-semibold text-black mb-3">
                   RBI-Compliant Security



                  </h3>
                  <p className="text-[#3F3F3F] text-[17px] md:text-[16px] leading-relaxed">
We follow all RBI guidelines and use leading security protocols to keep your data safe online.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center my-16 gap-[12px]  sm:gap-[14px] lg:gap-[24px] max-w-[1280px] w-full mx-auto">
          <style>{`
            .bg-gradient-radial {
              background: radial-gradient(ellipse at top center, #149D64 0%, #0B6351 10%);
            }
            .button-default {
              box-shadow:
                0 0 0 0.9px #47ffd48e,
                inset 0 0 20px rgba(25, 180, 140, 1.0),
                inset 0 0 10px rgba(42, 157, 114, 0.7);
            }
            .button-default:hover {
              box-shadow:
                0 0 0 4px #47ffd48e,
                inset 0 0 0px rgba(0, 0, 0, 0),
                inset 0 0 0px rgba(0, 0, 0, 0);
            }
          `}</style>
          <div className='h-[1px] w-full bg-[#8DDFBA]'></div>
          <button className="relative text-xl font-semibold text-white rounded-[18px] min-w-[176px] min-h-[56px] bg-black button-default hover:text-[#2a9d72] cursor-pointer transition-all duration-300 z-20"
onClick={() => navigate('/contact')}
>
            Let's Start
          </button>
          <div className='h-[1px] w-full bg-[#8DDFBA]'></div>
        </div>
        </div>
      </section>
      </>
  );
}